<template>
    <b-button-group v-show="listLength >= pageSize || offset > 0" size="sm" class="mb-2">
        <b-btn variant="outline-primary" class="mr-2" :disabled="offset === 0 || isDisabled"
            @click="setOffset(offset-pageSize)">
            &lsaquo;&nbsp;{{ $t('general.prevPage') }}
        </b-btn>
        <b-btn variant="outline-primary" :disabled="listLength < pageSize || isDisabled"
            @click="setOffset(offset+pageSize)">
            {{ $t('general.nextPage') }}&nbsp;&rsaquo;
        </b-btn>
    </b-button-group>
</template>

<script>
import AppData from '@/utils/appdata'

export default {
    name: 'pagination',
    mixins: [ AppData ],
    props: {
        pageSize: Number,
        offset: Number,
        listLength: Number,
        setOffset: Function
    },
    watch: {
        offset: function (newValue) {
            this.offset = newValue
        },
        listLength: function (newValue) {
            this.listLength = newValue
        }
    }
}
</script>
